import { Link } from 'react-router-dom';
import React from 'react';
import { Form, Modal, ButtonGroup } from 'react-bootstrap';
import { Card, CardBody, Row, Col } from 'reactstrap';
import { Eye, Backspace } from 'react-bootstrap-icons';
import 'jspdf-autotable';

import dateformat from 'dateformat';
import { Field } from 'formik';

function ShowFacture({ factureDetail, showDetailFactureModal, handleClose, keys }) {
    console.log('factureDetail', factureDetail);
    return (
        <>
            <Modal show={showDetailFactureModal} onHide={handleClose} size="xl">
                <Form>
                    <Modal.Header>
                        INFO FACTURE CLIENT
                        <Backspace onClick={handleClose} color="red" size={20} />
                    </Modal.Header>
                    <Modal.Body>
                        <div id="lightbody">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                <Form.Label column sm={4}>
                                                    N° pièce:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        aria-describedby="inputGroupPrepend"
                                                        disabled
                                                        size="sm"
                                                        value={keys === 'proforma' ? factureDetail?.noprof : factureDetail?.nofact}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                <Form.Label column sm={4}>
                                                    Client:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        aria-describedby="inputGroupPrepend"
                                                        disabled
                                                        size="sm"
                                                        value={factureDetail?.nomclient}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                <Form.Label column sm={4}>
                                                    {keys === 'proforma' ? 'Date proforma' : 'Date facture'}
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder={keys === 'proforma' ? 'Date proforma' : 'Date facture'}
                                                        aria-describedby="inputGroupPrepend"
                                                        disabled
                                                        size="sm"
                                                        value={
                                                            keys === 'proforma'
                                                                ? dateformat(factureDetail?.dateprof, 'dd-mm-yyyy')
                                                                : dateformat(factureDetail?.datefact, 'dd-mm-yyyy')
                                                        }
                                                    />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                <Form.Label column sm={4}>
                                                    TVA ?:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        aria-describedby="inputGroupPrepend"
                                                        disabled
                                                        size="sm"
                                                        value={factureDetail?.type_remise == '0' ? 'TVA applicable' : 'TVA non applicable'}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                <Form.Label column sm={4}>
                                                    Type remise:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        aria-describedby="inputGroupPrepend"
                                                        disabled
                                                        size="sm"
                                                        value={factureDetail?.type_remise == '0' ? 'Pourcentage' : 'Montant fixe'}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Valeur remise:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        id="remise_main"
                                                        type="number"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        value={factureDetail?.remise_main}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col md={8}>
                                            <table className="table table-striped-hover table-sm">
                                                <thead>
                                                    <tr>
                                                        {/* <th scope="col">#</th> */}
                                                        <th scope="col">Code art.</th>
                                                        <th scope="col">Descr. art.</th>
                                                        <th scope="col">Qté</th>
                                                        <th scope="col">Prix unit.</th>
                                                        <th scope="col">Remise</th>
                                                        <th scope="col">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {factureDetail?.lignefacture.map((d, index) => {
                                                        return (
                                                            <tr key={index} hover="true">
                                                                {/* <td>{d.id}</td> */}
                                                                <td>{d.qrbarre}</td>
                                                                <td>{d.descriptionart}</td>
                                                                <td>{d.pivot.quantite}</td>
                                                                <td>{d.pivot.prix || 'Néant'}</td>
                                                                <td>{d.pivot.remise}</td>
                                                                <td>
                                                                    <ButtonGroup aria-label="Basic example">
                                                                        <Link
                                                                            to={`#/admin/article/fiche/${d.id}`}
                                                                            title="Voir tous les détails de l'article"
                                                                        >
                                                                            <Eye size={20} color="royalblue" />
                                                                        </Link>
                                                                    </ButtonGroup>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Backspace onClick={handleClose} color="red" size={20} />
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default ShowFacture;
